import loadOnRoute from 'bundles/common/components/loadOnRoute';

// ADMIN ROUTES
export const ExternalAppsPage: ReturnType<typeof loadOnRoute> = loadOnRoute(
  () => import('bundles/manage-external-apps/components/admin/ExternalApps')
);

export const DiscoverExternalAppsPage: ReturnType<typeof loadOnRoute> = loadOnRoute(
  () => import('bundles/manage-external-apps/components/admin/discover/DiscoverApps')
);

export const ManageExternalAppsPage: ReturnType<typeof loadOnRoute> = loadOnRoute(
  () => import('bundles/manage-external-apps/components/admin/manage/InstitutionAppManager')
);

// TEACH ROUTES
export const CourseAppManager: ReturnType<typeof loadOnRoute> = loadOnRoute(
  () => import('bundles/manage-external-apps/components/teach/CourseAppManager')
);
